import { VideoPlayer } from "~/common/components/video/VideoPlayer";
import { ABOUT_CN_VIDEO_ID, VideoWidgetAttributes } from "~/models/videoprops";

/**
 * this front end script is responsible for controlling the card container's hide/show of the
 * content when the plus/minus button is clicked
 */
export function VideoView({ videoId }: VideoWidgetAttributes) {
  return (
    <div className="tw:flex tw:justify-center">
      <VideoPlayer videoId={videoId ?? ABOUT_CN_VIDEO_ID} />
    </div>
  );
}
